import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.744 4.928a3.3 3.3 0 0 1 2.3-.928h4.04c.89 0 1.742.357 2.364.992l1.644 1.675c.21.213.496.333.795.333A3.113 3.113 0 0 1 22 10.113v6.575A3.31 3.31 0 0 1 18.688 20H5.312A3.31 3.31 0 0 1 2 16.688v-6.55A3.137 3.137 0 0 1 5.137 7c.295 0 .578-.114.79-.319zM10 13a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_camera_filled-O-tYG7a3.js.map
